module.exports = __webpack_public_path__ + "images/category_lp/common/icon-company-1@2x_a87eeda87914bcf414d6cd5bf4284df1.png";